import { render, staticRenderFns } from "./comercio.view.vue?vue&type=template&id=794b1010&scoped=true"
import script from "./comercio.view.vue?vue&type=script&lang=js"
export * from "./comercio.view.vue?vue&type=script&lang=js"
import style0 from "./comercio.view.vue?vue&type=style&index=0&id=794b1010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794b1010",
  null
  
)

export default component.exports